import {Component, inject, Input, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {CurrencyService} from '../currency.service';
import {ActivatedRoute} from '@angular/router';
import {Currency, ICurrency} from '../../../shared/model';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';
import {EventManager} from '../../../core/services';
import {Observable} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import { ModalComponent } from '../../../shared/components/modal.component';

@Component({
  selector: 'app-currency-update',
  templateUrl: './currency-update.component.html',
  styleUrls: ['./currency-update.component.scss']
})
export class CurrencyUpdateComponent extends ModalComponent implements OnInit {
  btnLabel = 'Save';
  @Input() currency: Currency = null;
  isSaving = false;

  currencyForm = this.fb.group({
    id: [],
    name: ['', [Validators.required, Validators.maxLength(20)]],
    code: ['', [Validators.required, Validators.maxLength(10)]]
  });
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  constructor(
    private fb: FormBuilder,
    protected currencyService: CurrencyService,
    private modal: NzModalRef,
    public eventManager: EventManager) {
      super(eventManager);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.currency = this.nzModalData.currency;
    if (this.currency) {
      this.btnLabel = 'Update';
      this.updateForm(this.currency);
    }
  }

  updateForm(currency: ICurrency): void {
    this.currencyForm.patchValue({
      id: currency.id,
      name: currency.name,
      code: currency.code
    });
  }

  save(): void {
    this.isSaving = true;
    const currency = this.createCurrencyForm();
    if (currency.id) {
      this.subscribeToSaveResponse(this.currencyService.update(currency));
    } else {
      this.subscribeToSaveResponse(this.currencyService.create(currency));
    }
  }

  private createCurrencyForm(): ICurrency {
    return {
      ...new Currency(),
      id: this.currencyForm.get(['id'])!.value,
      name: this.currencyForm.get(['name'])!.value,
      code: this.currencyForm.get(['code'])!.value
    };
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<ICurrency>>): void {
    result.subscribe(
      () => this.onSaveSuccess(),
      () => this.onSaveError()
    );
  }

  protected onSaveSuccess(): void {
    this.eventManager.broadcast({
      name: 'currencyListModification',
      content: 'Changing an currency'
    });
    this.modal.destroy();
    this.isSaving = false;
  }

  protected onSaveError(): void {
    this.isSaving = false;
  }

  destroyModal(): void {
    this.modal.destroy();
  }
}
